<template>
    <div>
      <NavigationBar />
      <div>
        <div class="">
          <div class="uk-grid uk-grid-collapse" uk-grid>
            <div class="uk-width-1-2@s uk-flex uk-flex-middle">
              <div class=" uk-margin-large-top uk-margin-large-left uk-margin-medium-right">
                <h1 class="uk-text-bold" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">ROOMI EDC PIK 2</h1>
                <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">IDD - Indonesia Design District<br/>16A M.H. Thamrin Street, Salembaran Jaya, Kosambi District, Tangerang Regency, Banten 15214.</p>
                <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">(+62) 081112545968</p>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.6159121164646!2d106.70288230000001!3d-6.0473167000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f9c2e9a35f71%3A0xfa6084d51d31ec89!2sRoomi%20Store%20EDC%20PIK2!5e0!3m2!1sid!2sid!4v1705045124879!5m2!1sid!2sid" allowfullscreen="" loading="lazy" height="350" no-referrer-when-downgrade class="uk-width-full" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;"></iframe>
              </div>
            </div>
            <div class="uk-width-1-2@s">
              <div uk-scrollspy="cls: uk-animation-scale-up; delay: 100; repeat: true;" class="" uk-slideshow="autoplay: true" >
                <div class="uk-slideshow-items slider-contact">
                  <div>
                    <img :src="require('../assets/roomi_store/foto_store/TAMPAK DEPAN.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/roomi_store/foto_store/TAMPAK BELAKANG.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/roomi_store/foto_store/area pengunjung.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/roomi_store/foto_store/area display tv.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/roomi_store/foto_store/area cctv dan ott box.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/roomi_store/foto_store/testing spk.jpg')" alt="" uk-cover>
                  </div>
                </div>
                <div class="loading-overlay" uk-slideshow-loading></div>
              </div>
            </div>
            <div class="uk-width-1-2@s uk-flex uk-flex-middle">
              <div class=" uk-margin-large-top uk-margin-large-left uk-margin-medium-right">
                <h1 class="uk-text-bold" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">ROOMI BOTANI SQUARE</h1>
                <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">Botani Square Mall Bogor<br/> 40 Raya Pajajaran Street, Ground Floor, Tugu Kujang, Bogor Tengah District, Bogor City, West Java 16127.</p>
                <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">(+62) 081112545969</p>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1980.712251649596!2d106.8071254!3d-6.6014221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69c50006d64441%3A0x3e4c4e67f16b986e!2sROOMI%20Store%20-%20Botani%20Square%20Bogor!5e0!3m2!1sid!2sid!4v1697410914398!5m2!1sid!2sid" allowfullscreen="" loading="lazy" height="350" no-referrer-when-downgrade class="uk-width-full" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;"></iframe>
              </div>
            </div>
            <div class="uk-width-1-2@s">
              <div uk-scrollspy="cls: uk-animation-scale-up; delay: 100; repeat: true;" class="" uk-slideshow="autoplay: true" >
                <div class="uk-slideshow-items slider-contact">
                  <div>
                    <img :src="require('../assets/botani/depan.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/botani/samping kiri.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/botani/display cctv dari samping.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/botani/display cctv.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/botani/display spk 2.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/botani/display spk.jpg')" alt="" uk-cover>
                  </div>
                  <div>
                    <img :src="require('../assets/botani/samping kanan.jpg')" alt="" uk-cover>
                  </div>
                </div>
                <div class="loading-overlay" uk-slideshow-loading></div>
              </div>
            </div>
            <div class="uk-width-1-2@s uk-flex uk-flex-middle">
              <div class=" uk-margin-large-top uk-margin-large-left uk-margin-medium-right">
                <h1 class="uk-text-bold" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Explore Our Products <br />at <img width="150" :src="require('../assets/logo-best.png')" alt=""></h1>
                
                <ul class="uk-list uk-list-disc font-description" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
                    <li>Aeon Mall Deltamas, Central Cikarang, Bekasi Regency</li>
                    <li>Senayan City Mall, 4th Floor, Central Jakarta, DKI Jakarta</li>
                    <li>Summarecon, Mall Serpong, Kelapa Dua, Tangerang Regency</li>
                    <li>Central Park Mall, West Jakarta, DKI Jakarta</li>
                    <li>Aeon Mall BSD, Pagedangan District, Tangerang Regency</li>
                    <li>Summarecon, Mall Kelapa Gading, North Jakarta, DKI Jakarta</li>
                    <li>Summarecon, Mall Bekasi, North Bekasi, Bekasi Regency</li>
                </ul>
              </div>
            </div>
            <div class="uk-width-1-2@s">
              <div uk-scrollspy="cls: uk-animation-scale-up; delay: 100; repeat: true;" class="" uk-slideshow="autoplay: true" >
                <div class="uk-slideshow-items slider-contact">
                  <div>
                    <img :src="require('../assets/roomi_store/foto_store/aeon-deltamas.jpg')" alt="" uk-cover>
                  </div>
                  <!-- <div>
                    <img :src="require('../assets/roomi_store/foto_store/smb.jpg')" alt="" uk-cover>
                  </div> -->
                </div>
                <div class="loading-overlay" uk-slideshow-loading></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 class="uk-heading-divider"></h1>
      <Footer />
    </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
import UIkit from 'uikit';

export default {
  components: {
    NavigationBar,
    Footer,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 960;
    },
  },
  data() {
    return {
      loading: true,
      main_store: {},
      branch: [],
      official_store: [],
    };
  },
  mounted() {
    // this.getData();
    this.$nextTick(() => {
      const loadingOverlay = document.querySelector('.loading-overlay');
      const slideshow = UIkit.slideshow(document.querySelector('.uk-slideshow'), {
        beforeShow: function() {
          loadingOverlay.style.display = 'block';
        },
        afterShow: function() {
          loadingOverlay.style.display = 'none';
        }
      });
    });
  },
  methods: {
    getData() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}stores`)
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            const data = res.data;
            this.main_store = data.data.main_store;
            this.branch = data.data.branch;
            this.official_store = data.data.official_store;
          } else {
            UIkit.notification({
              message: "Something went wrong!",
              status: "danger",
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          UIkit.notification({
            message: "Something went wrong!",
            status: "danger",
          });
          this.loading = false;
        });
    },
    priceRupiah: function (number) {
      let reverse = number.toString().split("").reverse().join("");
      let ribuan = reverse.match(/\d{1,3}/g);
      ribuan = ribuan.join(".").split("").reverse().join("");
      return "Rp " + ribuan;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../custom/custom.less";

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: none;
}

.loading-overlay::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 5px solid #ccc;
  border-top-color: #333;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>